import axios from 'axios'

const state = {
    usersUsers: [],
    usersUser: null
};

const getters = {
    usersUsers: state => {
        return state.usersUsers
    },
    usersUser: state => {
        return state.usersUser
    }
};

const mutations = {
    usersUsers: (state, payload) => {
        return state.usersUsers = payload
    },
    usersUser: (state, payload) => {
        return state.usersUser = payload
    }
};

const actions = {
//GET
    usersGet({commit}) {
        return axios({
            method: 'GET',
            url: 'profiles-with-user',
            params: {
                pg: 0,
                batch: 20,
                role: 'USER'
            }
        })
        .then(({data}) => {
            commit('usersUsers', data.data)
        })
        .catch(err => {
            console.error('Ошибка скачивания списка пользователей: ', err)
        })
    },
    async usersGetUser({commit}, id) {
        try {
            const {data} = await axios({
                method: 'GET',
                url: `profiles/${id}`
            })
            
            commit('usersUser', data.data)

            return data.data
        } catch(e) {
            console.log(e)
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}